import * as $runtime from "../runtime.js";
import * as Control$dBind from "../Control.Bind/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dHeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dRecord$dExtra2 from "../Data.Record.Extra2/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Record$dExtra from "../Record.Extra/index.js";
import * as Restaumatic$dAddress from "../Restaumatic.Address/index.js";
import * as Restaumatic$dAnalytics$dTypes$dEvent from "../Restaumatic.Analytics.Types.Event/index.js";
import * as Restaumatic$dAnalytics$dTypes$dItemList from "../Restaumatic.Analytics.Types.ItemList/index.js";
import * as Restaumatic$dCart$dCart from "../Restaumatic.Cart.Cart/index.js";
import * as Restaumatic$dCart$dDetail from "../Restaumatic.Cart.Detail/index.js";
import * as Restaumatic$dCart$dProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic$dForm$dAction from "../Restaumatic.Form.Action/index.js";
import * as Restaumatic$dForm$dFinal from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic$dForm$dFormField from "../Restaumatic.Form.FormField/index.js";
import * as Restaumatic$dForm$dInternal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic$dForm$dMapping from "../Restaumatic.Form.Mapping/index.js";
import * as Restaumatic$dForm$dReadOnly from "../Restaumatic.Form.ReadOnly/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dMenu$dFilterPromotions from "../Restaumatic.Menu.FilterPromotions/index.js";
import * as Restaumatic$dMenu$dQuery from "../Restaumatic.Menu.Query/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dMenuConsumer from "../Restaumatic.Menu.V2.Types.MenuConsumer/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dOrderOrigin from "../Restaumatic.Menu.V2.Types.OrderOrigin/index.js";
import * as Restaumatic$dOrder$dTypes from "../Restaumatic.Order.Types/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dCartParams from "../Restaumatic.PromotionsEngine.Cart.CartParams/index.js";
import * as Restaumatic$dServices$dDelivery from "../Restaumatic.Services.Delivery/index.js";
import * as Restaumatic$dSite$dComponents$dCart$dDishesCalculator from "../Restaumatic.Site.Components.Cart.DishesCalculator/index.js";
import * as Restaumatic$dSite$dComponents$dCart$dTypes from "../Restaumatic.Site.Components.Cart.Types/index.js";
import * as Restaumatic$dSite$dComponents$dCrossSelling from "../Restaumatic.Site.Components.CrossSelling/index.js";
import * as Restaumatic$dSite$dTranslations$dKeys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Specular$dCallback from "../Specular.Callback/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dExtra$dModal from "../Specular.Dom.Extra.Modal/index.js";
import * as Specular$dFRP$dAsync from "../Specular.FRP.Async/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dHost from "../Specular.FRP.Host/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dProfiling from "../Specular.Profiling/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Utils$dTracking from "../Utils.Tracking/index.js";
import * as Web$dHTML from "../Web.HTML/index.js";
import * as Web$dHTML$dWindow from "../Web.HTML.Window/index.js";
const identity = x => x;
const measure = /* #__PURE__ */ Specular$dProfiling.measure(Specular$dInternal$dRIO.monadEffectRIO);
const getGlobalLocale = /* #__PURE__ */ Restaumatic$dI18n.getGlobalLocale(Effect$dClass.monadEffectEffect);
const $$new = /* #__PURE__ */ Specular$dRef.new(Specular$dInternal$dRIO.monadEffectRIO);
const newEvent = /* #__PURE__ */ Specular$dFRP$dBase.newEvent(Specular$dInternal$dRIO.monadEffectRIO);
const monadFRP = {MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder};
const performEvent = /* #__PURE__ */ Specular$dFRP$dAsync.performEvent(monadFRP);
const traverse = /* #__PURE__ */ (() => Data$dTraversable.traversableMaybe.traverse(Data$dMaybe.applicativeMaybe))();
const fromFoldable = /* #__PURE__ */ Data$dFoldable.foldlArray(m => a => Data$dMap$dInternal.insert(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.ordMenuConsumer)(a)()(m))(Data$dMap$dInternal.Leaf);
const foldDyn = /* #__PURE__ */ Specular$dFRP$dBase.foldDyn(monadFRP);
const subscribeEvent_ = /* #__PURE__ */ Specular$dFRP$dBase.subscribeNode(Specular$dInternal$dRIO.monadEffectRIO)(Specular$dDom$dBuilder.monadCleanupBuilder);
const for_ = /* #__PURE__ */ Data$dFoldable.for_(Effect.applicativeEffect)(Data$dFoldable.foldableMaybe);
const deliveryMethodIsSymbol = {reflectSymbol: () => "deliveryMethod"};
const restaurantIdIsSymbol = {reflectSymbol: () => "restaurantId"};
const rsequence2 = /* #__PURE__ */ Data$dRecord$dExtra2.rsequence2(Specular$dFRP$dBase.functorDynamic)()(Data$dMaybe.applicativeMaybe)(/* #__PURE__ */ Record$dExtra.sequenceRecordCons(deliveryMethodIsSymbol)()(Data$dMaybe.applyMaybe)(/* #__PURE__ */ Record$dExtra.sequenceRecordSingle(restaurantIdIsSymbol)()(Data$dMaybe.functorMaybe)()())()())()(Specular$dFRP$dBase.applicativeDynamic)(/* #__PURE__ */ Record$dExtra.sequenceRecordCons(deliveryMethodIsSymbol)()(Specular$dFRP$dBase.applyDynamic)(/* #__PURE__ */ Record$dExtra.sequenceRecordSingle(restaurantIdIsSymbol)()(Specular$dFRP$dBase.functorDynamic)()())()());
const sequenceDeliveryMethod = /* #__PURE__ */ Restaumatic$dOrder$dTypes.sequenceDeliveryMethod(Data$dMaybe.applicativeMaybe);
const uniqDyn = /* #__PURE__ */ (() => {
  const uniqDynBy1 = Specular$dFRP$dBase.uniqDynBy(monadFRP);
  return dictEq => uniqDynBy1(dictEq.eq);
})();
const eqDeliveryMethod = /* #__PURE__ */ Restaumatic$dOrder$dTypes.eqDeliveryMethod(Restaumatic$dAddress.eqLocatedDeliveryAddress)({
  eq: ra => rb => {
    if (ra.location.tag === "Nothing") { return rb.location.tag === "Nothing"; }
    if (ra.location.tag === "Just") {
      if (rb.location.tag === "Just") {
        if (ra.location._1.tag === "Table") {
          if (rb.location._1.tag === "Table") { return ra.location._1._1.number === rb.location._1._1.number; }
          return false;
        }
        if (ra.location._1.tag === "ServingLocation") {
          if (rb.location._1.tag === "ServingLocation") {
            return ra.location._1._1.areaId === rb.location._1._1.areaId && ra.location._1._1.areaName === rb.location._1._1.areaName && ra.location._1._1.pointName === rb.location._1._1.pointName;
          }
          return false;
        }
        return false;
      }
      return false;
    }
    return false;
  }
});
const uniqDyn1 = /* #__PURE__ */ uniqDyn({
  eq: x => y => {
    if (x.tag === "Nothing") { return y.tag === "Nothing"; }
    if (x.tag === "Just") {
      if (y.tag === "Just") {
        return eqDeliveryMethod.eq(x._1.deliveryMethod)(y._1.deliveryMethod) && (() => {
          if (x._1.restaurantId.tag === "Nothing") { return y._1.restaurantId.tag === "Nothing"; }
          if (x._1.restaurantId.tag === "Just") {
            if (y._1.restaurantId.tag === "Just") { return x._1.restaurantId._1 === y._1.restaurantId._1; }
            return false;
          }
          return false;
        })();
      }
      return false;
    }
    return false;
  }
});
const asyncRequestMaybe = /* #__PURE__ */ Specular$dFRP$dAsync.asyncRequestMaybe(Specular$dInternal$dRIO.monadEffectRIO)(monadFRP);
const uniqDyn2 = /* #__PURE__ */ uniqDyn({
  eq: x => y => {
    if (x.tag === "Nothing") { return y.tag === "Nothing"; }
    if (x.tag === "Just") {
      if (y.tag === "Just") { return eqDeliveryMethod.eq(x._1)(y._1); }
      return false;
    }
    return false;
  }
});
const holdDyn = /* #__PURE__ */ Specular$dFRP$dBase.foldDyn(monadFRP)(x => v => x);
const attachEvent = /* #__PURE__ */ Specular$dCallback.attachEvent()(monadFRP);
const max = x => y => {
  const v = Data$dOrd.ordInt.compare(x)(y);
  if (v.tag === "LT") { return y; }
  if (v.tag === "EQ") { return x; }
  if (v.tag === "GT") { return x; }
  $runtime.fail();
};
const rsequence = /* #__PURE__ */ Record$dExtra.sequenceRecord()(/* #__PURE__ */ Record$dExtra.sequenceRecordCons({reflectSymbol: () => "baseTotal"})()(Specular$dFRP$dBase.applyDynamic)(/* #__PURE__ */ Record$dExtra.sequenceRecordCons({
  reflectSymbol: () => "cart"
})()(Specular$dFRP$dBase.applyDynamic)(/* #__PURE__ */ Record$dExtra.sequenceRecordCons({reflectSymbol: () => "grandTotal"})()(Specular$dFRP$dBase.applyDynamic)(/* #__PURE__ */ Record$dExtra.sequenceRecordCons({
  reflectSymbol: () => "minOrderValue"
})()(Specular$dFRP$dBase.applyDynamic)(/* #__PURE__ */ Record$dExtra.sequenceRecordCons({reflectSymbol: () => "orderingPossible"})()(Specular$dFRP$dBase.applyDynamic)(/* #__PURE__ */ Record$dExtra.sequenceRecordSingle({
  reflectSymbol: () => "overlappingDishes"
})()(Specular$dFRP$dBase.functorDynamic)()())()())()())()())()())()());
const conj = /* #__PURE__ */ (() => Specular$dFRP$dBase.heytingAlgebraDynamic(Data$dHeytingAlgebra.heytingAlgebraBoolean).conj)();
const $$null = /* #__PURE__ */ Data$dFoldable.foldrArray(v => v1 => false)(true);
const addIsSymbol = {reflectSymbol: () => "add"};
const detailsIsSymbol = {reflectSymbol: () => "details"};
const onVisibleIsSymbol = {reflectSymbol: () => "onVisible"};
const productKeyIsSymbol = {reflectSymbol: () => "productKey"};
const quantityIsSymbol = {reflectSymbol: () => "quantity"};
const makeEmptyImpl = /* #__PURE__ */ (() => Restaumatic$dForm$dInternal.makeEmpty_Record()(Restaumatic$dForm$dInternal.makeEmptyRecordCons({reflectSymbol: () => "finished"})(Restaumatic$dForm$dInternal.makeEmptyRecordCons({
  reflectSymbol: () => "presentation"
})(Restaumatic$dForm$dInternal.makeEmptyRecordCons({reflectSymbol: () => "result"})(Restaumatic$dForm$dInternal.makeEmptyRecordCons({reflectSymbol: () => "selections"})(Restaumatic$dForm$dInternal.makeEmptyRecordCons({
  reflectSymbol: () => "total"
})(Restaumatic$dForm$dInternal.makeEmptyRecordNil)(Restaumatic$dForm$dReadOnly.makeEmptyReadOnly)()())(Restaumatic$dForm$dMapping.makeEmpty(Data$dOrd.ordString)(Data$dUUID.showUUID)({
  addContext: Restaumatic$dForm$dInternal.addContextRecordCons(addIsSymbol)(Restaumatic$dForm$dInternal.addContextRecordCons(detailsIsSymbol)(Restaumatic$dForm$dInternal.addContextRecordCons(onVisibleIsSymbol)(Restaumatic$dForm$dInternal.addContextRecordCons(productKeyIsSymbol)(Restaumatic$dForm$dInternal.addContextRecordCons(quantityIsSymbol)(Restaumatic$dForm$dInternal.addContextRecordNil)(Restaumatic$dForm$dFormField.addContextFormField$p)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dAction.addContextAction)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dAction.addContextAction)()().addContextRecord(Type$dProxy.Proxy)
})(Restaumatic$dForm$dInternal.makeEmpty_Record()(Restaumatic$dForm$dInternal.makeEmptyRecordCons(addIsSymbol)(Restaumatic$dForm$dInternal.makeEmptyRecordCons(detailsIsSymbol)(Restaumatic$dForm$dInternal.makeEmptyRecordCons(onVisibleIsSymbol)(Restaumatic$dForm$dInternal.makeEmptyRecordCons(productKeyIsSymbol)(Restaumatic$dForm$dInternal.makeEmptyRecordCons(quantityIsSymbol)(Restaumatic$dForm$dInternal.makeEmptyRecordNil)(Restaumatic$dForm$dFormField.makeEmptyFormField$pPartia)()())(Restaumatic$dForm$dReadOnly.makeEmptyReadOnly)()())(Restaumatic$dForm$dAction.makeEmptyAction)()())(Restaumatic$dForm$dReadOnly.makeEmptyReadOnly)()())(Restaumatic$dForm$dAction.makeEmptyAction)()())))()())(Restaumatic$dForm$dReadOnly.makeEmptyReadOnly)()())(Restaumatic$dForm$dReadOnly.makeEmptyReadOnly)()())(Restaumatic$dForm$dAction.makeEmptyAction)()()).makeEmptyImpl)();
const defineForm = /* #__PURE__ */ Specular$dFRP$dHost.liftHost(Specular$dDom$dBuilder.monadCleanupBuilder)(Specular$dInternal$dRIO.monadEffectRIO);
const selectFirstPromotionalItem = menu => menuEnv => predicate => cart => {
  const v = Data$dArray.find(predicate)(cart.promotionalItems);
  if (v.tag === "Just") {
    return Restaumatic$dCart$dCart.applyActionWithAssignMode(Restaumatic$dPromotionsEngine$dCart$dCartParams.AutoAssign)(Restaumatic$dCart$dCart.$Action(
      "SetPromotionalItemSelected",
      v._1,
      true
    ))(menu)(menuEnv)(cart);
  }
  if (v.tag === "Nothing") { return cart; }
  $runtime.fail();
};
const modifyCouponCode = v => v1 => v2 => v3 => v4 => {
  if (v3.tag === "Nothing") {
    return {
      menu: v2,
      cart: Restaumatic$dCart$dCart.applyActionWithAssignMode(Restaumatic$dPromotionsEngine$dCart$dCartParams.AutoAssign)(Restaumatic$dCart$dCart.$Action(
        "ModifyCouponCode",
        Data$dMaybe.Nothing
      ))(v2)(v4.menuEnv)(v4.cart),
      menuEnv: v4.menuEnv
    };
  }
  if (v3.tag === "Just") {
    const newMenu = Restaumatic$dMenu$dFilterPromotions.filterPromotions(v)(v1)({...v2, promotions: v3._1._2});
    return {
      menu: newMenu,
      cart: Restaumatic$dCart$dCart.applyActionWithAssignMode(Restaumatic$dPromotionsEngine$dCart$dCartParams.AutoAssign)(Restaumatic$dCart$dCart.$Action(
        "ModifyCouponCode",
        Data$dMaybe.$Maybe("Just", v3._1._1)
      ))(newMenu)(v4.menuEnv)(v4.cart),
      menuEnv: v4.menuEnv
    };
  }
  $runtime.fail();
};
const analyticsItem = locale => list => item => (
  {
    name: (() => {
      if (item.details.tag === "Nothing") { return ""; }
      if (item.details.tag === "Just") { return Restaumatic$dCart$dDetail.productName(locale)(item.details._1); }
      $runtime.fail();
    })(),
    quantity: item.quantity,
    price: (() => {
      if (item.unitPrice.tag === "Nothing") { return 0; }
      if (item.unitPrice.tag === "Just") { return item.unitPrice._1; }
      $runtime.fail();
    })(),
    category: "NonPromotional",
    list
  }
);
const control = config => measure("Cart.control")((() => {
  const baseMenu = config.baseMenu;
  return Specular$dInternal$dRIO.bindImpl(getGlobalLocale)(locale => Specular$dInternal$dRIO.bindImpl($$new(true))(displayDeliveryFormRef => {
    const editDelivery = displayDeliveryFormRef._2(_old => true);
    return Specular$dInternal$dRIO.bindImpl($$new(config.menu))(menuRef => {
      const menu = menuRef._1;
      return Specular$dInternal$dRIO.bindImpl(newEvent)(action => Specular$dInternal$dRIO.bindImpl(newEvent)(clearCart => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.mapImpl(Specular$dFRP$dBase.filterEvent(identity))(performEvent(Specular$dFRP$dBase.functorEvent.map(x => Effect$dAff._liftEffect(() => {
        const win = Web$dHTML.window();
        return Web$dHTML$dWindow.confirm(Restaumatic$dI18n._translate(
          Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.widgets.cart.clear_confirmation),
          {}
        ))(win)();
      }))(clearCart.event))))(clearCartConfirmed => {
        const externalAddItemE = Specular$dFRP$dBase.filterMapEvent(Specular$dFRP$dBase.identity)(Specular$dFRP$dBase.attachDynWith(menu1 => v => Data$dMaybe.applyMaybe.apply((() => {
          const $0 = traverse(x => {
            const $0 = Restaumatic$dMenu$dQuery.applicativeMenuQuery.pure(x)(menu1);
            if ($0.tag === "Left") { return Data$dMaybe.Nothing; }
            if ($0.tag === "Right") { return Data$dMaybe.$Maybe("Just", $0._1); }
            $runtime.fail();
          })(v.old);
          if ($0.tag === "Just") {
            return Data$dMaybe.$Maybe(
              "Just",
              (() => {
                const $1 = $0._1;
                return v2 => ({oldKey: $1, newKey: v2, quantity: v.quantity, list: v.list});
              })()
            );
          }
          return Data$dMaybe.Nothing;
        })())((() => {
          const $0 = Restaumatic$dMenu$dQuery.applicativeMenuQuery.pure(v.new)(menu1);
          if ($0.tag === "Left") { return Data$dMaybe.Nothing; }
          if ($0.tag === "Right") { return Data$dMaybe.$Maybe("Just", $0._1); }
          $runtime.fail();
        })()))(menu)(config.addOrReplaceItem));
        const cartAction = Specular$dFRP$dBase.leftmost([
          action.event,
          Specular$dFRP$dBase.functorEvent.map(v => {
            const newExtendedKey = {key: v.newKey, note: Data$dMaybe.Nothing};
            if (v.oldKey.tag === "Nothing") { return Restaumatic$dCart$dCart.$Action("ModifyQuantity", newExtendedKey, v1 => v1 + v.quantity | 0); }
            if (v.oldKey.tag === "Just") { return Restaumatic$dCart$dCart.$Action("ReplaceItem", {key: v.oldKey._1, note: Data$dMaybe.Nothing}, newExtendedKey); }
            $runtime.fail();
          })(externalAddItemE)
        ]);
        return Specular$dInternal$dRIO.bindImpl(newEvent)(promotionsChanged => {
          const modifyCart = Specular$dFRP$dBase.leftmost([
            Specular$dFRP$dBase.functorEvent.map(action1 => v => (
              {
                menu: v.menu,
                cart: Restaumatic$dCart$dCart.applyActionWithAssignMode(Restaumatic$dPromotionsEngine$dCart$dCartParams.AutoAssign)(action1)(v.menu)(v.menuEnv)(v.cart),
                menuEnv: v.menuEnv
              }
            ))(cartAction),
            Specular$dFRP$dBase.functorEvent.map(v => v1 => ({menu: baseMenu, cart: Restaumatic$dCart$dCart.empty, menuEnv: v1.menuEnv}))(clearCartConfirmed),
            Specular$dFRP$dBase.functorEvent.map(pred => v => ({menu: v.menu, cart: selectFirstPromotionalItem(v.menu)(v.menuEnv)(pred)(v.cart), menuEnv: v.menuEnv}))(config.selectFirstPromotionalItem),
            Specular$dFRP$dBase.functorEvent.map(modifyCouponCode(config.now)(fromFoldable([config.menuConsumer]))(baseMenu))(promotionsChanged.event),
            Specular$dFRP$dBase.functorEvent.map(menuEnv => v => (
              {
                cart: Restaumatic$dCart$dCart.applyActionWithAssignMode(Restaumatic$dPromotionsEngine$dCart$dCartParams.AutoAssign)(Restaumatic$dCart$dCart.RecalculateProductDetails)(v.menu)(menuEnv)(v.cart),
                menu: v.menu,
                menuEnv
              }
            ))(config.menuEnv)
          ]);
          return Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.readDynamic(Specular$dInternal$dRIO.monadEffectRIO)(config.menuEnv))(initialMenuEnv => Specular$dInternal$dRIO.bindImpl(foldDyn(Data$dFunction.apply)({
            menu: config.menu,
            cart: config.initialCart,
            menuEnv: initialMenuEnv
          })(modifyCart))(cartWithMenu => {
            const cart = Specular$dFRP$dBase.functorDynamic.map(v => v.cart)(cartWithMenu);
            return Specular$dInternal$dRIO.bindImpl(subscribeEvent_(x => menuRef._2(_old => x))(Specular$dFRP$dBase.functorDynamic.map(v => v.menu)(cartWithMenu)))(() => Specular$dInternal$dRIO.bindImpl(subscribeEvent_(v => {
              const $0 = v.list;
              const $1 = v.newKey;
              const $2 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(cart);
              return () => {
                const cart$p = $2();
                return for_(Restaumatic$dCart$dCart.lookupProduct($1)(cart$p.products))(pi => {
                  const $3 = Restaumatic$dAnalytics$dTypes$dEvent.$Event("AddToCart", analyticsItem(locale)($0)(pi));
                  return () => {
                    const currency = Utils$dTracking.getCurrencyEff();
                    return Utils$dTracking.trackEventEff(Utils$dTracking.toNamedEvent(currency)($3))();
                  };
                })();
              };
            })(externalAddItemE))(() => Specular$dInternal$dRIO.bindImpl($$new(Data$dMaybe.Nothing))(deliveryMethodRef => {
              const deliveryMethod = deliveryMethodRef._1;
              const baseTotal = Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dCart$dCart.baseCustomerTotal)(cart);
              return Specular$dInternal$dRIO.bindImpl(uniqDyn1(rsequence2({
                restaurantId: (() => {
                  const $0 = Data$dMaybe.$Maybe("Just", Data$dMaybe.$Maybe("Just", config.restaurant.id));
                  return (() => {
                    const n = Specular$dInternal$dIncremental.constant($0);
                    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
                    return n;
                  })();
                })(),
                deliveryMethod: Specular$dFRP$dBase.functorDynamic.map(x => {
                  if (x.tag === "Just") { return sequenceDeliveryMethod(x._1); }
                  return Data$dMaybe.Nothing;
                })(deliveryMethod)
              })))(uniqRequest => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.mapImpl(v => v.delivery)(Specular$dDom$dBuilder.monadAskBuilder.ask))(v => Specular$dInternal$dRIO.bindImpl(asyncRequestMaybe(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.functorMaybe.map(v.deliveryCost))(uniqRequest)))(deliveryStatus => {
                const $0 = Specular$dFRP$dBase.functorDynamic.map(v2 => {
                  if (v2.tag === "Loaded") {
                    if (v2._1.tag === "Right") {
                      if (v2._1._1.tag === "Ok") { return Data$dFoldable.find(Data$dFoldable.foldableArray)(r => r.restaurantId === config.restaurant.id)(v2._1._1._1); }
                      return Data$dMaybe.Nothing;
                    }
                    return Data$dMaybe.Nothing;
                  }
                  return Data$dMaybe.Nothing;
                })(deliveryStatus);
                const deliveryCost = Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dServices$dDelivery.deliveryCostOrFree)(baseTotal))($0);
                const deliveryCostOrZero = Specular$dFRP$dBase.functorDynamic.map(v2 => {
                  if (v2.tag === "Nothing") { return 0; }
                  if (v2.tag === "Just") { return v2._1; }
                  $runtime.fail();
                })(deliveryCost);
                return Specular$dInternal$dRIO.bindImpl(uniqDyn2(Specular$dFRP$dBase.functorDynamic.map(x => {
                  if (x.tag === "Just") { return sequenceDeliveryMethod(x._1); }
                  return Data$dMaybe.Nothing;
                })(deliveryMethod)))(lastDeliveryMethod => Specular$dInternal$dRIO.bindImpl(holdDyn(true)(Specular$dFRP$dBase.leftmost([
                  Specular$dFRP$dBase.functorEvent.map(v$1 => true)(lastDeliveryMethod),
                  Specular$dFRP$dBase.functorEvent.map(v$1 => false)(Specular$dFRP$dBase.filterMapEvent(Specular$dFRP$dBase.identity)($0))
                ])))(shouldDisplayDeliveryForm => Specular$dInternal$dRIO.bindImpl(attachEvent(Specular$dFRP$dBase.sampleAt(Specular$dFRP$dBase.functorEvent.map(v$1 => Specular$dFRP$dBase.identity)(Specular$dFRP$dBase.leftmost([
                  config.showCart,
                  Specular$dFRP$dBase.functorEvent.map(v$1 => {})(config.addOrReplaceItem)
                ])))(shouldDisplayDeliveryForm))(x => displayDeliveryFormRef._2(_old => x)))(() => {
                  const packagingContainersCost = Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v2 => v3 => {
                    if (v3.tag === "Nothing") { return 0; }
                    if (v3.tag === "Just") {
                      if (v3._1.tag === "DeliveryMethodDineIn") { return 0; }
                      return v2.packagingContainersCost;
                    }
                    return v2.packagingContainersCost;
                  })(cart))(lastDeliveryMethod);
                  const overlappingDishes = Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(c => m => !Restaumatic$dSite$dComponents$dCart$dDishesCalculator.eqDeliveryTimesStatus.eq(Restaumatic$dSite$dComponents$dCart$dDishesCalculator.calculateAllDayDeliveryTimesStatus(config.now)(c)(m))(Restaumatic$dSite$dComponents$dCart$dDishesCalculator.NoneAvailable))(cart))(menu);
                  const itemCount = Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dCart$dCart.itemCount)(cart);
                  const grandTotal = Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(base => delivery1 => containers => max(0)((
                    base + delivery1 | 0
                  ) + containers | 0))(baseTotal))(deliveryCostOrZero))(packagingContainersCost);
                  const errors = Specular$dFRP$dBase.functorDynamic.map(v2 => {
                    if (v2.cart.products.length === 0) { return []; }
                    return Data$dSemigroup.concatArray((() => {
                      const $1 = v2.grandTotal < v2.minOrderValue;
                      const $2 = [
                        Restaumatic$dSite$dComponents$dCart$dTypes.$$$Error(
                          "MinOrderValueWarning",
                          {minValue: v2.minOrderValue, missingValue: v2.minOrderValue - v2.grandTotal | 0}
                        )
                      ];
                      if (!$1) { return []; }
                      if ($1) { return $2; }
                      $runtime.fail();
                    })())(Data$dSemigroup.concatArray((() => {
                      if (config.restaurant.maxOrderValue.tag === "Just") {
                        const $1 = v2.grandTotal > config.restaurant.maxOrderValue._1;
                        if (!$1) { return []; }
                        if ($1) { return [Restaumatic$dSite$dComponents$dCart$dTypes.$$$Error("MaxOrderValueWarning", {maxValue: config.restaurant.maxOrderValue._1})]; }
                        $runtime.fail();
                      }
                      if (config.restaurant.maxOrderValue.tag === "Nothing") { return []; }
                      $runtime.fail();
                    })())(Data$dSemigroup.concatArray(v2.orderingPossible ? [] : [Restaumatic$dSite$dComponents$dCart$dTypes.OrderingNotPossible])(v2.overlappingDishes
                      ? []
                      : [Restaumatic$dSite$dComponents$dCart$dTypes.NotOverlappingDishes])));
                  })(rsequence({
                    minOrderValue: Specular$dFRP$dBase.functorDynamic.map((() => {
                      const $1 = config.restaurant.minOrderValue;
                      return v2 => {
                        if (v2.tag === "Nothing") { return $1; }
                        if (v2.tag === "Just") { return v2._1.minOrderValue; }
                        $runtime.fail();
                      };
                    })())($0),
                    baseTotal,
                    grandTotal,
                    orderingPossible: config.orderingPossible,
                    overlappingDishes,
                    cart
                  }));
                  const canOrder = conj(conj(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dCart$dCart.canOrder)(cart))(conj(overlappingDishes)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dCart$dCart.hasNoErrors)(cart))))(Specular$dFRP$dBase.functorDynamic.map($$null)(errors));
                  const canClearCart = Specular$dFRP$dBase.functorDynamic.map(x => x.products.length !== 0)(cart);
                  return Specular$dInternal$dRIO.bindImpl(newEvent)(externalSubmit => {
                    const submit = Specular$dFRP$dBase.leftmost([externalSubmit.event, config.submit]);
                    return Specular$dInternal$dRIO.bindImpl(subscribeEvent_(cart$p => {
                      const $1 = Restaumatic$dAnalytics$dTypes$dEvent.$Event(
                        "BeginCheckout",
                        {items: Data$dFunctor.arrayMap(analyticsItem(locale)(Data$dMaybe.Nothing))(cart$p.products)}
                      );
                      return () => {
                        const currency = Utils$dTracking.getCurrencyEff();
                        return Utils$dTracking.trackEventEff(Utils$dTracking.toNamedEvent(currency)($1))();
                      };
                    })(Specular$dFRP$dBase.sampleAt(Specular$dFRP$dBase.functorEvent.map(v$1 => Specular$dFRP$dBase.identity)(submit))(cart)))(() => Specular$dInternal$dRIO.bindImpl(newEvent)(closeCart => {
                      const modalAction = Specular$dFRP$dBase.leftmost([
                        Specular$dFRP$dBase.functorEvent.map(v$1 => Specular$dDom$dExtra$dModal.Hide)(closeCart.event),
                        Specular$dFRP$dBase.functorEvent.map(v$1 => Specular$dDom$dExtra$dModal.Show)(config.showCart),
                        Specular$dFRP$dBase.functorEvent.map(v$1 => Specular$dDom$dExtra$dModal.Hide)(submit)
                      ]);
                      return Specular$dInternal$dRIO.bindImpl(makeEmptyImpl({name: ["cartCrossSelling"]}))(v2 => Specular$dInternal$dRIO.bindImpl(defineForm(Restaumatic$dSite$dComponents$dCrossSelling.define()()({
                        restaurantId: config.restaurant.id,
                        menu: config.menu,
                        productIds: Specular$dFRP$dBase.functorDynamic.map(m => {
                          if (m.tag === "Left") { return Data$dEither.$Either("Left", m._1); }
                          if (m.tag === "Right") {
                            return Data$dEither.$Either(
                              "Right",
                              Control$dBind.arrayBind(m._1.products)(item => Control$dBind.arrayBind(item.key.tag === "MenuProduct" ? [item.key._1] : [])(key => Control$dBind.arrayBind(Data$dArray.fromFoldableImpl(
                                Data$dFoldable.foldrArray,
                                Data$dRecord.unsafeGet("parts")(key)
                              ))(part => [Data$dRecord.unsafeGet("productId")(part)])))
                            );
                          }
                          $runtime.fail();
                        })(Restaumatic$dForm$dFinal.makeFinal(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(cart))),
                        menuOrderOrigin: Restaumatic$dMenu$dV2$dTypes$dOrderOrigin.Online,
                        field: v2,
                        mode: Restaumatic$dSite$dComponents$dCrossSelling.$Mode(
                          "ExternalState",
                          {
                            addItem: key => action.fire(Restaumatic$dCart$dCart.$Action(
                              "ModifyQuantity",
                              {key: Restaumatic$dCart$dProductKey.$ProductKey("MenuProduct", key), note: Data$dMaybe.Nothing},
                              v3 => v3 + 1 | 0
                            )),
                            quantityAndPrice: key => {
                              const $1 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(cart);
                              return () => {
                                const cart$p = $1();
                                const v3 = Restaumatic$dCart$dCart.lookupProduct(Restaumatic$dCart$dProductKey.$ProductKey("MenuProduct", key))(cart$p.products);
                                return (() => {
                                  if (v3.tag === "Nothing") { return {quantity: 0, unitPrice: 0}; }
                                  if (v3.tag === "Just") {
                                    return {
                                      quantity: v3._1.quantity,
                                      unitPrice: (() => {
                                        if (v3._1.unitPrice.tag === "Nothing") { return 0; }
                                        if (v3._1.unitPrice.tag === "Just") { return v3._1.unitPrice._1; }
                                        $runtime.fail();
                                      })()
                                    };
                                  }
                                  $runtime.fail();
                                })();
                              };
                            }
                          }
                        ),
                        menuEnv: initialMenuEnv,
                        menuConsumer: config.menuConsumer,
                        list: Restaumatic$dAnalytics$dTypes$dItemList.CartCrossSelling
                      })))(() => Specular$dInternal$dRIO.bindImpl(subscribeEvent_(v3 => {
                        const $1 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(v2.finished.effect._1);
                        return () => {
                          const e = $1();
                          return e()();
                        };
                      })(submit))(() => Specular$dInternal$dRIO.pureImpl(Data$dTuple.$Tuple(
                        {
                          cart,
                          deliveryCost,
                          grandTotal,
                          canClearCart,
                          deliveryStatus,
                          deliveryMethod,
                          modalAction,
                          canOrder,
                          errors,
                          displayDeliveryForm: displayDeliveryFormRef._1,
                          packagingContainersCost,
                          action: action.fire,
                          clearCart: clearCart.fire(),
                          closeCart: closeCart.fire(),
                          submit: externalSubmit.fire(),
                          promotionsChanged: promotionsChanged.fire,
                          editDelivery,
                          setDeliveryMethod: x => deliveryMethodRef._2(_old => x),
                          crossSelling: v2
                        },
                        {
                          itemCount,
                          canOrder,
                          grandTotal,
                          cart,
                          deliveryMethod: Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.functorMaybe.map(Restaumatic$dOrder$dTypes.toFulfillmentMethodType))(deliveryMethod),
                          submit
                        }
                      )))));
                    }));
                  });
                })));
              })));
            })));
          }));
        });
      })));
    });
  }));
})());
export {
  addIsSymbol,
  analyticsItem,
  asyncRequestMaybe,
  attachEvent,
  conj,
  control,
  defineForm,
  deliveryMethodIsSymbol,
  detailsIsSymbol,
  eqDeliveryMethod,
  foldDyn,
  for_,
  fromFoldable,
  getGlobalLocale,
  holdDyn,
  identity,
  makeEmptyImpl,
  max,
  measure,
  modifyCouponCode,
  monadFRP,
  $$new as new,
  newEvent,
  $$null as null,
  onVisibleIsSymbol,
  performEvent,
  productKeyIsSymbol,
  quantityIsSymbol,
  restaurantIdIsSymbol,
  rsequence,
  rsequence2,
  selectFirstPromotionalItem,
  sequenceDeliveryMethod,
  subscribeEvent_,
  traverse,
  uniqDyn,
  uniqDyn1,
  uniqDyn2
};
